import { render, staticRenderFns } from "./battery.vue?vue&type=template&id=486285a8&scoped=true&"
import script from "./battery.vue?vue&type=script&lang=js&"
export * from "./battery.vue?vue&type=script&lang=js&"
import style0 from "./battery.vue?vue&type=style&index=0&id=486285a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486285a8",
  null
  
)

export default component.exports